import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'agencyDate',
  standalone: false
})
@Injectable()
export class AgencyDatePipe implements PipeTransform {
  constructor(private readonly datePipe: DatePipe) {}

  public transform(date: Date, withTime = false, simpleTimeFormat = false, customFormat = ''): string {
    if (withTime) {
      if (simpleTimeFormat) {
        return this.datePipe.transform((date && date.userLocalDate) || date, 'MM/dd/yyyy hh:mm a');
      } else {
        return this.datePipe.transform((date && date.userLocalDate) || date, `MM/dd/yyyy 'at' hh:mm a`);
      }
    }

    return this.datePipe.transform((date && date.userLocalDate) || date, customFormat || 'MM/dd/yyyy');
  }
}
